import { EntraConnectionDto } from "../../../../autogen/bff-api";

export const hasEverSynced = (
  connection: Pick<EntraConnectionDto, "groups" | "lastReconciledAt">,
): boolean =>
  connection.groups.length > 0 || connection.lastReconciledAt != null;
